<div class="threshold-widget-wrapper">
  <div class="header">
    <div class="description">{{description}}</div>
  </div>
  <div class="header-name" *ngIf="threshold.appName">
    <div class="title">Application:</div>
    <div class="text title">{{threshold.appName}}</div>
  </div>
  <div class="header-name" *ngIf="threshold.siteName">
    <div class="title">Site:</div>
    <div class="text title">{{threshold.siteName}}</div>
  </div>
  <div class="slider-content">
    <div class="slider" *ngIf="threshold.singleSlider">
      <vertical-single-slider [options]="options" (setThreshold)="setThreshold($event)" [from]="threshold.valueFrom">
      </vertical-single-slider>
    </div>
    <div class="slider" *ngIf="!threshold.singleSlider">
      <vertical-slider [options]="options" (setThreshold)="setThreshold($event)" [from]="threshold.valueFrom" [to]="threshold.valueTo">
      </vertical-slider>
    </div>
  </div>
</div>
